
























































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Inairequipment from "../../../store/entities/inairequipment";
@Component
export default class CreatInairequipments extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  inairequipment: Inairequipment = new Inairequipment();
  idisable: boolean = false;
  selwarehouselist = [];
  selfloorlist = [];
  created() {}
  gflist = [];
  displaynone = "";
  seltime = [
    { value: 1, label: "1分钟" },
    { value: 5, label: "5分钟" },
    { value: 10, label: "10分钟" },
    { value: 15, label: "15分钟" },
    { value: 30, label: "30分钟" },
    { value: 60, label: "60分钟" },
    { value: 120, label: "120分钟" },
    { value: 240, label: "240分钟" },
    { value: 360, label: "360分钟" },
    { value: 720, label: "720分钟" },
    { value: 1440, label: "1440分钟" },
  ];
  visibleChange(value: boolean) {
    this.selgId();
    if (!value) {
      this.$emit("input", value);
    }
  }
  get smokecrib() {
    return this.$store.state.smokecrib.filterlist;
  }
  get inairthreshold() {
    return this.$store.state.inairthreshold.list;
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  get gwequipment() {
    return this.$store.state.gwequipment.list;
  }

  selfactory(value: Number) {
    this.inairequipment.ftId = value;
    if (value != 0 && value != undefined) {
      this.getselwarehouse();
    }
  }
  selwarehouse(value: Number) {
    this.inairequipment.wId = value;
    if (value != 0 && value != undefined) {
      this.getselfloor();
    } else {
      this.inairequipment.fId = 0;
      this.selfloorlist = [];
    }
    // this.getfloor();
  }
  selfloor(value: Number) {
    this.inairequipment.fId = value;
  }
  selEth() {
    this.displaynone = "display:none";
  }
  selth() {
    this.displaynone = "";
  }
  selgId() {
    var gwelist = this.$store.state.gwequipment.list;
    var faclist = this.$store.state.factory.list;
    var wlist = this.$store.state.warehouse.list;
    var flist = this.$store.state.floor.list;
    var globallist = [];
    for (var i = 0; i < gwelist.length; i++) {
      var gweId = gwelist[i].ftId;
      for (var j = 0; j < faclist.length; j++) {
        var facId = faclist[j].id;
        if (gweId == facId) {
          globallist[i] = faclist[j].fName;
        }
      }
      for (var w = 0; w < wlist.length; w++) {
        if (gwelist[i].wId == wlist[w].id) {
          globallist[i] = globallist[i] + wlist[w].wName;
        }
      }
      for (var f = 0; f < flist.length; f++) {
        if (gwelist[i].fId == flist[f].id) {
          globallist[i] = globallist[i] + flist[f].fName;
        }
      }
      if (gwelist[i].frequency == null) {
        this.gflist[i] = { value: gwelist[i].id, label: globallist[i] };
      } else {
        this.gflist[i] = {
          value: gwelist[i].id,
          label: globallist[i] + gwelist[i].frequency,
        };
      }
    }
  }
  async getselwarehouse() {
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.inairequipment,
    });
  }
  async getselfloor() {
    //下拉库房加载楼层
    //filters
    this.selfloorlist = await this.$store.dispatch({
      type: "floor/RegetAll",
      data: this.inairequipment,
    });
  }
  save() {
    (this.$refs.inairequipmentForm as any).validate(async (valid: boolean) => {
      this.displaynone = "";
      if (valid) {
        this.idisable = true;
        if (this.inairequipment.updateInterval == true) {
          this.inairequipment.updateInterval = 1;
        } else {
          this.inairequipment.updateInterval = 0;
        }
        console.log(this.inairequipment);
        await this.$store.dispatch({
          type: "inairequipment/create",
          data: this.inairequipment,
        });
        (this.$refs.inairequipmentForm as any).resetFields();
        this.$emit("save-success");
        setTimeout(() => {
          this.idisable = false; //点击一次时隔两秒后才能再次点击
        }, 2000);
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.inairequipmentForm as any).resetFields();
    this.$emit("input", false);
    this.$emit("Radio", false);
    this.displaynone = "";
    this.selwarehouselist = [];
    this.selfloorlist = [];
  }
  inairequipmentRule = {
    ftId: [
      {
        type: "number",
        required: true,
        message: "请选择库区",
        trigger: "change",
      },
    ],
    wId: [
      {
        type: "number",
        required: true,
        message: "请选择库房",
        trigger: "change",
      },
    ],
    SNID: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [
      {
        type: "number",
        required: true,
        message: "请选择楼层",
        trigger: "change",
      },
    ],
    locationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    // number: [{required: true, message: "请填写位置编号", trigger: "blur" }],
    gId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
    acquisitionInterval: [
      {
        type: "number",
        required: true,
        message: "请选择采集间隔",
        trigger: "change",
      },
    ],
    // gId:[{type:"number", required: true, message: "请选择网关", trigger: "change" }]
  };
}
